import { EnglishArabicDTO } from "bbsf-controls"
export class SectorModel
{
      Id:number
      IDEncrypted:string
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      DepartmentsCount :number
}
     